export const LANDING_EVENTS = Object.freeze({
  LANDING_PAGE_VIEWED: {
    name: 'landing_page_viewed',
    category: 'Landing',
    description: 'LandingPage 页面首次展示时触发',
    // 页面曝光类事件显式抬到 full 档（2026-10-27）。理由：timezone / browser_language 只在
    // full 档携带，而它们是**会话级环境锚点**——只要会话里有一条 page_view 带上，整段会话
    // 就能按时区/浏览器语言归因。若页面曝光落进 standard，则「只逛页面、不进上传链路」的用户
    // 整段会话一条都没有（实测 2026-10-20~27：51 个 landing 用户里 27 个全站 0 条 timezone）。
    // 预算：声明峰值 10 + 5 + 1 = 16 ≪ 25，安全。
    globalsProfile: 'full',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_type',
      'navigation_trigger', 'lang', 'is_logged_in', 'content_id', 'content_type', 'landing_version'
    ]
  },
  LANDING_SECTION_VIEWED: {
    name: 'landing_section_viewed',
    category: 'Landing',
    description: 'LandingPage section 首次进入视口时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_type',
      'method', 'landing_section', 'section_index', 'content_id', 'content_type',
      'action_status', 'reason_code', 'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_NAV_CLICKED: {
    name: 'landing_nav_clicked',
    category: 'Landing',
    description: 'Landing 顶部导航或站内导航入口点击时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'content_id', 'content_type',
      'cta_type', 'destination_type', 'destination_id', 'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_CTA_CLICKED: {
    name: 'landing_cta_clicked',
    category: 'Landing',
    description: 'Landing CTA 点击时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'cta_type', 'destination_type', 'destination_id',
      'content_id', 'content_type', 'plan_id', 'billing_period', 'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_CTA_NAVIGATION_COMPLETED: {
    name: 'landing_cta_navigation_completed',
    category: 'Landing',
    description: 'Landing CTA 或导航触发的滚动/路由跳转完成时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'cta_type', 'destination_type', 'destination_id',
      'content_id', 'content_type', 'reason_code', 'duration_ms', 'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_OPTION_CHANGED: {
    name: 'landing_option_changed',
    category: 'Landing',
    description: 'Landing 内稳定选项或展示状态变化时触发',
    requiredParams: ['option_name'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'option_value', 'previous_value',
      'content_id', 'content_type', 'feature_key', 'faq_key',
      'billing_period', 'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_WAITLIST_SUBMIT_STARTED: {
    name: 'landing_waitlist_submit_started',
    category: 'Landing',
    description: 'Waitlist 表单校验通过并开始提交时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'email_domain', 'is_business_email',
      'email_prefilled', 'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_WAITLIST_SUBMIT_COMPLETED: {
    name: 'landing_waitlist_submit_completed',
    category: 'Landing',
    description: 'Waitlist 表单提交成功、重复、失败或被前端阻断后触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'reason_code', 'waitlist_status',
      'email_domain', 'is_business_email', 'email_prefilled',
      'duration_ms', 'http_status', 'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_CONTENT_CLICKED: {
    name: 'landing_content_clicked',
    category: 'Landing',
    description: 'Landing 中 Blog 等内容导流点击时触发',
    requiredParams: [],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_name',
      'element_type', 'method', 'content_id', 'content_type',
      'destination_type', 'destination_id', 'action_status', 'reason_code', 'blog_slug',
      'lang', 'is_logged_in', 'landing_version'
    ]
  },
  LANDING_PRICING_LOAD_COMPLETED: {
    name: 'landing_pricing_load_completed',
    category: 'Landing',
    description: 'Landing Pricing Section 计划数据加载完成、失败或为空时触发',
    requiredParams: ['action_status'],
    optionalParams: [
      'event_label', 'module_name', 'source_position', 'element_type',
      'method', 'reason_code', 'duration_ms', 'http_status',
      'content_type', 'lang', 'is_logged_in', 'landing_version'
    ]
  }
});
